import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { faWarehouse, faGear, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';

import sessionManager from '../../SessionManager';
import './MenuMagazzinoClienti.css';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, type?: 'group'): MenuItem {
    return {
        key,
        icon,
        label,
        type,
    } as MenuItem;
}

const items: MenuItem[] = [
    getItem('Magazzino', 'MagazzinoClienti', <FontAwesomeIcon size="3x" icon={faWarehouse} />),
    { type: 'divider' },
    getItem('Lavorazioni', 'LavorazioniCliente', <FontAwesomeIcon size="3x" icon={faGear} />),
    { type: 'divider' },
    getItem('Fatture', 'FattureCliente', <FontAwesomeIcon size="3x" icon={faFileInvoice} />),
    { type: 'divider' },
    getItem('D.D.T.', 'DDTResoCliente', <FontAwesomeIcon size="3x" icon={faFileInvoice} />),
    { type: 'divider' },
    getItem('Log out', 'logout', <FontAwesomeIcon size="3x" icon={faFileInvoice} />),
];

type MenuMagazzinoClientiPars = {
    currentMenu: string;
};
export default function MenuMagazzinoClienti(par: MenuMagazzinoClientiPars) {
    const [collapsed, setCollapsed] = useState(false);
    const [current, setCurrent] = useState(par.currentMenu);

    const navigate = useNavigate();

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const logOutClick = () => {
        sessionStorage.removeItem('tokencliente');
        sessionStorage.removeItem('data');
        sessionManager.clearSession();

        navigate('/loginClienti');
    };

    const onClick: MenuProps['onClick'] = (e) => {
        setCurrent(e.key);

        if (e.key === 'logout') logOutClick();
        else navigate('/' + e.key);
    };

    return (
        <div>
            <Menu
                className="menu"
                defaultSelectedKeys={[par.currentMenu]}
                theme="light"
                items={items}
                onClick={onClick}
                mode="horizontal"
            ></Menu>
        </div>
    );
}
